import jquery from 'jquery';
window.jquery = jquery;
window.$ = jquery;
window.jQuery = jquery;
